import React from 'react';

const divstyle = 'flex items-center justify-center my-12';
const texttitle = 'text-center font-times text-2xl';
const textsubtitle = ' text-xl font-times font-bold';
const textpar = ' text-xl font-times text-justify mx-14';

function MiModeloTrabajo(){
    return(
        <div className='container mx-auto py-14'>

            <div className={divstyle}>
                <h1 className={texttitle}>MI MODELO DE TRANSFORMACIÓN</h1>  
            </div>
            <div className={divstyle}>
                <p className={textpar}>
                    La mayoría intenta cambiar resultados trabajando solo en la superficie.<br/>
                    Yo trabajo en el sistema.<br/>
                    Mi intervención se basa en tres fases estratégicas:<br/>

                </p>
            </div>

            <div className='grid grid-cols-1 md:grid-cols-2 gap-2 py-10 m-5 '>

                <div className='flex flex-col items-center justify-center '>
                    <h2 className={textsubtitle}>
                        Diagnóstico Estratégico<br/>
                    </h2>
                    <p className={textpar}>
                        Identificamos el origen real del bloqueo.<br/>
                        No el síntoma. No la excusa. El origen.<br/>
                        Analizamos mentalidad, liderazgo, estructura operativa, <br/> toma de decisiones y gestión emocional.<br/>
                        Sin diagnóstico claro, no hay solución sostenible.<br/>

                    </p>
                    
                </div>

                <div className='flex flex-col items-center justify-center'>
                    <h2 className={textsubtitle}>
                        Reestructuración Interna<br/>
                    </h2>
                    <p className={textpar}>
                        Rediseñamos el sistema.<br/>
                        Mentalidad.<br/>
                        Hábitos.<br/>
                        Procesos.<br/>
                        Estrategia de ejecución.<br/>
                        Instalamos disciplina, claridad y estándares elevados.<br/>
                        Aquí se produce el cambio real.<br/>

                    </p>
                </div>
            </div>

            <div className='flex flex-col items-center justify-center mx-5'>
                <h2 className={`${texttitle} text-justify mx-14`}>
                    Implementación de Alto Rendimiento
                </h2>
                <p className={textpar}>
                    Convertimos la claridad en acción medible.<br/>
                    Definimos métricas.<br/>
                    Ajustamos decisiones.<br/>
                    Optimizamos liderazgo.<br/>
                    Creamos consistencia.<br/>
                    El resultado no es motivación.<br/>
                    Es crecimiento sostenible.

                </p>
            </div>

            <div className={divstyle}>
                <p className={`${texttitle} text-justify mx-14`}>
                    Cuando una persona transforma su mentalidad, comienza a transformar su historia… <br/>y ese es el proceso que estoy aquí para acompañarte a construir.
                </p>
            </div>

            <div className='flex flex-col items-center justify-center'>
                <h2 className={textsubtitle}>
                    Lo que encontrarás aquí
                </h2>
                <ul>
                    <li className={textpar}>Mentoría</li>
                    <li className={textpar}>Crecimiento personal</li>
                    <li className={textpar}>Mentalidad de éxito</li>
                    <li className={textpar}>Desarrollo espiritual</li>
                    <li className={textpar}>Transformación de vida</li>
                </ul>
            </div>

        </div>
    );
}

export default MiModeloTrabajo;